import { GoTemplateDataProperty } from "@/utils/go-template-data-structure/property";

export class GoTemplateDataString extends GoTemplateDataProperty {
	constructor(name:string, displayedName:string | {toString():string}) {
		super();
		this.name = name;
		this.displayedName = displayedName.toString();
	}
}